// extracted by mini-css-extract-plugin
export var MenuIsOpen = "header-navigation-menu-module--MenuIsOpen--66oBO";
export var backdrop = "header-navigation-menu-module--backdrop--B2yqr";
export var drawer = "header-navigation-menu-module--drawer--qEpUu";
export var menuCloseButton = "header-navigation-menu-module--menuCloseButton--DcbjI";
export var navItem = "header-navigation-menu-module--navItem--6hNjG";
export var navigationBar = "header-navigation-menu-module--navigationBar--jNf6t";
export var navigationBarContent = "header-navigation-menu-module--navigationBarContent--OaTq1";